import { KeyAndDisplay, ComparisonValue, SecurityStatus } from '../api/octopus';
import { ActivityTimeline } from './activity-timeline';
import { EntityType } from './entity';
import { EntryType } from './entry-type';
import { ListItem } from './list-item';
import { Session } from './session';
import { User } from './user';

export enum DialogType {
  confirm = 0,
  alert = 1,
}

export enum ActionType {
  completed = 0,
  delete = 1,
}

export enum ActivityType {
  regular = 0,
  actionPlan = 1,
  recurring = 2,
  workflowTask = 3,
}

// The Activity property a field column sorts by: its cell's SortValue, because the column shows
// formatted text (a number or a date sorted as that text would be out of order).
export const activitySortField = (columnId: string): string =>
  `${columnId}SortValue`;

export interface Activity {
  [name: string]: unknown;
  key: string | null;
  type: number;
  secStatus: SecurityStatus;
  completed: boolean;
  creator: string;
  startDate: string;
  endDate: string;
  userKeys: string[];
  completedByKeys?: string[];
  abEntries: KeyAndDisplay[];
  leads: KeyAndDisplay[];
  with?: ListItem<string> | null;
  recurrence: string | null;
  isActionPlan: boolean;
  isLastActivity: boolean;
  isWorkflowActivity: boolean;
}

export interface ActivityConfirmDialog {
  dialogType: DialogType;
  actionType: ActionType;
  activityType: ActivityType;
}

export type ActivityDateField = 'DateTime' | 'EffectiveDate';

export interface ActivityQueryParam {
  key?: string | string[] | null;
  entryType?: EntryType | null;
  users?: string[];
  creators?: string[];
  duedate?: ComparisonValue;
  dateField?: ActivityDateField;
  recurrence?: string | null;
  showCompleted?: boolean;
  showDisabledUsers?: boolean;
}

export interface ActivityManagerModuleConfiguration {
  session: Session;
  currentUser: User;
  users: User[];
}

export interface ActivityManagerFilters {
  basicFilter: ActivityManagerBasicFilters;
  customDateFilter: ActivityManagerCustomDateFilters;
}

export interface ActivityManagerBasicFilters {
  users: string[] | 'all';
  duedate: string;
  dateField?: ActivityDateField;
  showCompleted: boolean;
}

export interface ActivityManagerCustomDateFilters {
  dateRange: {
    start: Date | null;
    end: Date | null;
  };
}

export interface ToUpdateActivity {
  isNew: boolean;
  type?: EntityType | EntryType;
  key?: string | null;
  newKey?: string | null;
}

export type ActivityContactAction = 'call' | 'email';

export interface ActivityGridColumn {
  type: EntryType;
  clickable: boolean;
  contactAction?: ActivityContactAction;
}

export interface ActivityTimelineUpcomingOverdue {
  overdue: Array<ActivityTimeline>;
  upcoming: Array<ActivityTimeline>;
}

export enum ActivityColumnField {
  Name = 'entry',
  Subject = 'subject',
  Regarding = 'with',
}
